import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions.js'
import getters from './getters.js';
import state from './state.js';
import mutations from './mutations.js';

Vue.use(Vuex)

// 从localStorage恢复状态
const savedState = (() => {
  try {
    const saved = localStorage.getItem('xcStore');
    return saved ? JSON.parse(saved) : {};
  } catch (e) {
    return {};
  }
})();

// 合并初始状态和持久化状态
const initState = {
  ...state,
  ...savedState,
  // 强制覆盖这些关键状态
  platformType: savedState.platformType || 'portal',
  platformTypeLoaded: savedState.platformTypeLoaded || false
};

const store = new Vuex.Store({
  actions,
  getters,
  state: initState,
  mutations
});

// 每次mutation后自动保存到localStorage
store.subscribe((mutation, state) => {
  try {
    // 只持久化必要的状态
    const toSave = {
      platformType: state.platformType,
      platformTypeLoaded: state.platformTypeLoaded,
      Login: state.Login,
      Router: state.Router,
      LoanInfos: state.LoanInfos,
      ShowLoanInfo: state.ShowLoanInfo,
      CompanyName: state.CompanyName
    };
    localStorage.setItem('xcStore', JSON.stringify(toSave));
  } catch (e) {
    console.warn('Vuex持久化失败:', e);
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js